import React from 'react'
import RowComponent from './CardRiepilogoRow'
import { Col, Row } from 'antd'
import moment from 'moment'
import constants from '../assets/constants'
import { LoadingOutlined } from '@ant-design/icons'
import _ from 'lodash'

const RiepilogoCardFotoDescrizione = (props) => {
  const titolo = _.get(props.formValue, 'titolo')
  const descrizione = _.get(props.formValue, 'descrizione')
  const images = _.get(props.formValue, 'images', [])
  const appuntamentoData = _.get(props.formValue, 'prenotazioneData')
  const appuntamentoOrario = _.get(
    _.find(
      constants.orariPrenotazione,
      (item) => item.value === props.formValue.prenotazioneOrario
    ),
    'label'
  )
  const nome = _.get(props.formValue, 'nome')
  const telefono = _.get(props.formValue, 'telefono')
  return (
    <>
      <RowComponent
        testo={
          <Row>
            <Col span={24}>
              {titolo ? (
                <strong>{titolo}</strong>
              ) : (
                <span>
                  <span className="text-warning">Titolo:</span>
                  <span className="text-gray-400"> - non specificato</span>
                </span>
              )}
            </Col>
            <Col span={24}>
              {descrizione ? (
                <span>{descrizione}</span>
              ) : (
                <span>
                  <span className="text-warning">Descrizione:</span>
                  <span className="text-gray-400"> - non specificato</span>
                </span>
              )}
            </Col>
          </Row>
        }
        onIconClick={() => props.goToStep(0, 1)}
      />

      <RowComponent
        testo={
          <Row>
            <span className="font-semibold text-lg">Foto</span>
            <Col span={24}>
              {_.size(images) > 0 ? (
                <>
                  <div className="flex flex-wrap">
                    <Row gutter={[8, 8]} className="w-full">
                      {_.map(images, (image, index) => (
                        <Col
                          xs={8}
                          sm={8}
                          md={6}
                          lg={6}
                          style={{
                            display: 'flex',
                          }}
                        >
                          {_.size(_.words(image, 'data:'), 'index') > 0 ? (
                            <div className="rounded max-h-32 h-32 flex items-center justify-center w-full">
                              <LoadingOutlined
                                style={{
                                  fontSize: 32,
                                }}
                              />
                            </div>
                          ) : (
                            <img
                              className="rounded max-h-32 h-full w-full object-cover"
                              src={`${process.env.REACT_APP_WEBSITE_PATH}/uploads/${image.visualizationImage}`}
                            />
                          )}
                        </Col>
                      ))}
                    </Row>
                  </div>
                </>
              ) : (
                <span>
                  <span className="text-gray-400">Nessuna foto caricata</span>
                </span>
              )}
            </Col>
            <Col span={24}>
              {!!appuntamentoData && !!appuntamentoOrario ? (
                <span>
                  Il tuo appuntamento con il fotografo è{' '}
                  <strong>
                    {moment(appuntamentoData).format('dddd D MMMM YYYY')}
                  </strong>{' '}
                  alle ore <strong>{appuntamentoOrario}</strong>
                </span>
              ) : (
                <span>
                  <span className="text-warning">Appuntamento:</span>
                  <span className="text-gray-400"> - non specificato</span>
                </span>
              )}
            </Col>
          </Row>
        }
        onIconClick={() => props.goToStep(4, 2)}
      />

      <RowComponent
        testo={
          <Row>
            <Col span={24}>
              {nome ? (
                <span className="font-semibold text-lg">
                  Il proprietario è <strong>{nome}</strong>
                </span>
              ) : (
                <span>
                  <span className="text-warning">Proprietario:</span>
                  <span className="text-gray-400"> - non specificato</span>
                </span>
              )}
            </Col>
            <Col span={24}>
              {telefono ? (
                <span>
                  Numero di telefono <strong>{telefono}</strong>
                </span>
              ) : (
                <span>
                  <span className="text-warning">Numero di telefono:</span>
                  <span className="text-gray-400"> - non specificato</span>
                </span>
              )}
            </Col>
          </Row>
        }
        onIconClick={() => props.goToStep(1, 1)}
      />
    </>
  )
}

export default RiepilogoCardFotoDescrizione
